import {
  ITonneVerschwundenCreateBody,
  ITonneVerschwundenResponseBody,
} from "../../store/slices/tonneVerschwunden";
import { adminInstance, instance } from "../api";

const getViersenTonneVerschwundenStreetsAndPlaces = () => {
  return instance
    .get<{
      places: {
        id: string;
        gemeindeBezeichnung: string;
        gemeindePostleitzahl: number;
        gemeindeNummer: number;
      }[];
      streets: {
        id: string;
        gemeindeNummer: number;
        strasseBezeichnung: string;
      }[];
    }>("tonne-verschwunden/data/viersen")
    .then((res) => res.data);
};

const getAdminTonneVerschwunden = ({
  direction,
  page,
  pageSize,
  searchValue,
  sort,
  signal,
  startDate,
  endDate,
  status,
  type,
}: {
  sort?: string;
  direction?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
  signal: AbortSignal;
  startDate?: Date | null | string;
  endDate?: Date | null | string;
  status?: string[];
  type?: string[];
}) => {
  return adminInstance
    .get<{
      totalCount: number;
      data: ITonneVerschwundenResponseBody[];
    }>("/admin/tonne-verschwunden", {
      params: {
        direction,
        page,
        pageSize,
        searchValue,
        sort,
        startDate,
        endDate,
        status,
        type,
      },
      signal,
    })
    .then((res) => res.data);
};

const changeItemsStatuses = ({
  ids,
  status,
}: {
  ids: string[];
  status: string;
}) => {
  return adminInstance
    .put<ITonneVerschwundenResponseBody[]>(`/admin/tonne-verschwunden/status`, {
      status,
      ids,
    })
    .then((res) => res.data);
};

const getAdminTonneVerschwundenItemById = (id: string) => {
  return adminInstance
    .get<ITonneVerschwundenResponseBody>(`/admin/tonne-verschwunden/${id}`)
    .then((res) => res.data);
};

const updateStatusById = ({
  id,
  status,
  message,
}: {
  id: string;
  status: string;
  message?: string;
}) => {
  return adminInstance
    .put<ITonneVerschwundenResponseBody>(
      `/admin/tonne-verschwunden/${id}/status`,
      {
        status,
        message,
      },
    )
    .then((res) => res.data);
};

const checkMultipleTonneVerschwundenOnObject = ({
  fraction,
  place,
  street,
  volume,
  homeNumber,
  signal,
}: {
  fraction: string;
  volume: string;
  place: string;
  street: string;
  homeNumber: string;
  signal: AbortSignal;
}) => {
  return instance
    .get<{
      hasMultipleTonnen: boolean;
      totalQuantity: number;
    }>("tonne-verschwunden/check-tonnen", {
      params: {
        fraction,
        place,
        street,
        homeNumber,
        volume,
      },
      signal,
    })
    .then((res) => res.data);
};

const createTonneVerschwunden = (data: ITonneVerschwundenCreateBody) => {
  return instance.post("/tonne-verschwunden", data).then((res) => res.data);
};

const TonneVerschwunden = {
  get: {
    getViersenTonneVerschwundenStreetsAndPlaces,
    getAdminTonneVerschwunden,
    getAdminTonneVerschwundenItemById,
    checkMultipleTonneVerschwundenOnObject,
  },
  post: {
    createTonneVerschwunden,
  },
  put: {
    changeItemsStatuses,
    updateStatusById,
  },
};

export default TonneVerschwunden;
